import { Table, Typography } from 'antd'
import {
  AdminsFinanceGetVendorListResponseItem,
  VendorDirectionEnum,
  VendorSortFieldEnum,
} from 'generated/api'
import { ColumnsType } from 'antd/es/table'
import IconSortAscDesc from 'components/tableHelpers/IconSortAscDesc'
import ButtonLink from 'components/button/Button'
import { mapStatusVendor, mapVendorType } from 'helpers/wording'
import { useNavigate } from 'react-router-dom'

interface PropsMerchantTable {
  data: AdminsFinanceGetVendorListResponseItem[]
  sortBy: VendorDirectionEnum
  sortField: VendorSortFieldEnum
  isLoading: boolean
  setSortingVendor: (columnKey: VendorSortFieldEnum) => void
}

function VendorsTable(props: PropsMerchantTable) {
  const navigate = useNavigate()
  const { data, isLoading, sortBy, sortField, setSortingVendor } = props

  const columnsOrder: ColumnsType<AdminsFinanceGetVendorListResponseItem> = [
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">No.</Typography.Text>
        </div>
      ),
      width: '5%',
      dataIndex: 'nomor',
      key: 'nomor',
      render: (_text, _row, index) => (
        <div data-testid="link_column_name" className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">{index + 1}.</Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">Nama Vendor</Typography.Text>
        </div>
      ),
      width: '20%',
      dataIndex: 'name',
      key: 'name',
      render: text => (
        <div className="flex flex-col">
          <Typography.Text className="font-medium text-gray-800">{text}</Typography.Text>
        </div>
      ),
    },
    {
      title: (
        <div
          className="flex justify-between items-center hover:cursor-pointer"
          data-testid="column_head_vendor_type"
        >
          <Typography.Text className="font-semibold text-gray-800">Tipe Vendor</Typography.Text>
          <IconSortAscDesc
            columnName={VendorSortFieldEnum.Type}
            columnSortBy={sortBy}
            columnSortField={sortField}
          />
        </div>
      ),
      width: '20%',
      dataIndex: 'type',
      key: 'type',
      onHeaderCell: () => {
        return {
          onClick: () => setSortingVendor(VendorSortFieldEnum.Type),
        }
      },
      render: text => {
        return <Typography.Text className="font-medium">{mapVendorType(text)}</Typography.Text>
      },
    },
    {
      title: (
        <div
          className="flex justify-between items-center hover:cursor-pointer"
          data-testid="column_head_vendor_owner_name"
        >
          <Typography.Text className="font-semibold text-gray-800">Nama Pemilik</Typography.Text>
          <IconSortAscDesc
            columnName={VendorSortFieldEnum.OwnerName}
            columnSortBy={sortBy}
            columnSortField={sortField}
          />
        </div>
      ),
      width: '20%',
      dataIndex: 'ownerName',
      key: 'ownerName',
      onHeaderCell: () => {
        return {
          onClick: () => setSortingVendor(VendorSortFieldEnum.OwnerName),
        }
      },
      render: text => {
        return <Typography.Text className="font-medium">{text}</Typography.Text>
      },
    },
    {
      title: (
        <div
          className="flex justify-between items-center hover:cursor-pointer"
          data-testid="column_head_vendor_regency"
        >
          <Typography.Text className="font-semibold text-gray-800">Kota/Kabupaten</Typography.Text>
          <IconSortAscDesc
            columnName={VendorSortFieldEnum.Regency}
            columnSortBy={sortBy}
            columnSortField={sortField}
          />
        </div>
      ),
      width: '20%',
      dataIndex: 'regency',
      key: 'regency',
      onHeaderCell: () => {
        return {
          onClick: () => setSortingVendor(VendorSortFieldEnum.Regency),
        }
      },
      render: text => {
        return <Typography.Text className="font-medium">{text}</Typography.Text>
      },
    },
    {
      title: (
        <div
          className="flex justify-between items-center hover:cursor-pointer"
          data-testid="column_head_vendor_status"
        >
          <Typography.Text className="font-semibold text-gray-800">Status</Typography.Text>
          <IconSortAscDesc
            columnName={VendorSortFieldEnum.Status}
            columnSortBy={sortBy}
            columnSortField={sortField}
          />
        </div>
      ),
      width: '10%',
      dataIndex: 'status',
      key: 'status',
      onHeaderCell: () => {
        return {
          onClick: () => setSortingVendor(VendorSortFieldEnum.Status),
        }
      },
      render: stockLocationStatus => {
        return (
          <Typography.Text className="font-medium">
            {mapStatusVendor(stockLocationStatus)}
          </Typography.Text>
        )
      },
    },
    {
      title: (
        <div className="flex">
          <Typography.Text className="font-semibold text-gray-800">Aksi</Typography.Text>
        </div>
      ),
      width: '5%',
      dataIndex: '_action',
      key: '_action',
      render: (_text, row) => (
        <div data-testid="link_column_edit" className="flex flex-col">
          <ButtonLink
            data-testid={`button_manage_stock_${row.id}`}
            variant="outline-primary"
            block={true}
            label="Edit"
            className="border font-bold"
            onClick={() => navigate(`/inventory/vendors/${row.id}`)}
          />
        </div>
      ),
    },
  ]

  return (
    <Table
      rowKey="id"
      data-testid="tbl_vendor"
      loading={isLoading}
      className="table-primary table-primary--admin sticky-table-header"
      columns={columnsOrder}
      dataSource={data}
      pagination={false}
    />
  )
}

export default VendorsTable
